import styled from 'styled-components'

export const GIF = styled.img`
  width: 100%;
  margin-bottom: 50px;
  height: ${({ height = 'initial' }) => height};
`
